<base-support-modal [title]="title" [isLoading]="isLoading" [btnOkClass]="'btn-danger'" [btnOkLabel]="'Сменить'" (onOk)="ok()" >
	<p>
		Номер счёта: <span class="badge badge-info">{{invoiceNumber}}</span>
		<br>
		Тариф: <span class="badge badge-info">{{tariffId.toUpperCase()}}</span>
		<br>
		Действителен до: <span class="badge badge-info">{{dateToFormatted}}</span>
		<br>
		Валюта оплаты: <span class="badge badge-info">{{currency}}</span>
	</p>

	<div class="alert alert-warning" *ngIf="recurrentProfile">
		Данный счёт имеет активную подписку №: <span class="badge badge-warning">{{recurrentProfile}}</span>
	</div>

	<div class="form-group">
		<label class="control-label">Новый тариф</label>
		<select [(ngModel)]="newTariffId" class="form-control">
			<ng-template ngFor let-tariff [ngForOf]="tariffs">
				<option value="{{tariff._id}}">{{i18nTariffs[tariff._id].name}} &mdash; {{tariff.amountBase[currency] / 100}} {{currency}} в мес.	</option>
			</ng-template>
		</select>
	</div>
</base-support-modal>
